import {TABLET_BREAKPOINT_WIDTH} from '@wandb/weave/common/css/globals.styles';
import styled, {css} from 'styled-components';

const flexRowStyles = `
  display: flex;
  align-items: center;
  align-content: center;
`;

export const ReportPageHeader = styled.div<{$isInEditMode?: boolean}>`
  ${flexRowStyles}
  justify-content: ${({$isInEditMode}) =>
    $isInEditMode ? 'space-between' : 'flex-end'};
  gap: 16px;
  padding: 12px 12px 12px 6px;

  ${({$isInEditMode}) =>
    $isInEditMode &&
    css`
      @media only screen and (max-width: ${TABLET_BREAKPOINT_WIDTH + 150}px) {
        flex-direction: column;
        align-items: flex-start;
      }
    `}

  // This is intentionally added, so the correct font is rendered in
  // fully connected for the report menu actions
  font-family: 'Source Sans 3';
`;

export const FlexRow = styled.div`
  ${flexRowStyles}
`;
